import { useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
};

export const FilmSection = () => {
  const [playing, setPlaying] = useState(false);

  return (
    <section className="bg-ink py-24 md:py-28" data-testid="film-section">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <motion.div {...fadeUp} className="max-w-2xl mb-10">
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-brand-light">Watch our film</p>
          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-white">Experience Clocktower Cars</h2>
          <p className="mt-5 text-lg leading-relaxed text-white/60">
            A glimpse of the premium, professional service behind every journey — executive vehicles, expert chauffeurs and effortless travel across Surrey, Sussex and London.
          </p>
        </motion.div>

        <motion.div {...fadeUp} transition={{ ...fadeUp.transition, delay: 0.1 }} className="relative aspect-video overflow-hidden rounded-3xl ring-1 ring-white/10 shadow-[0_40px_80px_-30px_rgba(0,0,0,0.7)]">
          {playing ? (
            <video
              className="h-full w-full object-cover"
              src="/videos/commercial.mp4"
              poster="/videos/commercial-poster.jpg"
              controls
              autoPlay
              playsInline
              data-testid="film-video"
            />
          ) : (
            <button
              type="button"
              onClick={() => setPlaying(true)}
              data-testid="film-play-btn"
              aria-label="Play the Clocktower Cars film"
              className="group absolute inset-0 h-full w-full"
            >
              <img src="/videos/commercial-poster.jpg" alt="Clocktower Cars film" className="h-full w-full object-cover" />
              <span className="absolute inset-0 bg-gradient-to-t from-ink/70 via-ink/10 to-transparent" />
              <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                <span className="grid h-20 w-20 place-items-center rounded-full bg-brand text-white shadow-[0_10px_40px_rgba(31,157,42,0.5)] transition-transform duration-300 group-hover:scale-110">
                  <Play className="h-8 w-8 translate-x-0.5" fill="currentColor" strokeWidth={0} />
                </span>
                <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-brand/40" />
              </span>
              <span className="absolute bottom-6 left-6 flex items-center gap-2 text-sm font-semibold text-white/90">
                <span className="h-2 w-2 rounded-full bg-brand-light" /> Clocktower Cars — the film
              </span>
            </button>
          )}
        </motion.div>
      </div>
    </section>
  );
};
